var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"holder"},[_c('h2',{attrs:{"id":"txt1"},domProps:{"innerHTML":_vm._s(_vm.targetTxt)}})])}
var staticRenderFns = []

export { render, staticRenderFns }